<template>
  <div class="contractItem mb_5">
    <div class="contractItem__index">
      <div>建議{{ contractIndex + 1 }}</div>
      <div>繳別:{{ contractData.pay_freq_nm }}</div>
    </div>
    <div class="contractItem__title">
      <div>商品名稱</div>
      <div>商品<br />代號</div>
      <div>繳費<br />年期</div>
      <div>被保險人</div>
      <div class="justify-content-end text-right">保額/計畫別</div>
      <div>應繳保費<br />(折減前)</div>
    </div>
    <!-- 主約 -->
    <div
      class="contractItem__MC"
      v-for="(MC, index) in contractData.mc_prod_list"
      :key="'mc_' + index"
    >
      <div class="justify-content-start text-left">{{ MC.prod_name }}</div>
      <div>{{ MC.prod_id }}</div>
      <div>{{ MC.pay_prd }}{{ MC.pay_prd != "" ? "年" : "" }}</div>
      <div>{{ truncate(MC.insured_name) }}</div>
      <div class="justify-content-end">
        {{ formatMethods(MC.amt) }}{{ MC.amt != "" ? MC.amt_unit_nm : "" }}
      </div>
      <div class="justify-content-end">
        {{ formatMethods(MC.premium) }}{{ contractData.curr_nm }}
      </div>
    </div>
    <!-- 附約 -->
    <div
      class="contractItem__SC"
      v-for="(SC, index) in contractData.sc_prod_list"
      :key="'sc_' + index"
    >
      <div class="justify-content-start text-left">└ {{ SC.prod_name }}</div>
      <div>{{ SC.prod_id }}</div>
      <div>{{ SC.pay_prd }}{{ SC.pay_prd != "" ? "年" : "" }}</div>
      <div>{{ truncate(SC.insured_name) }}</div>
      <div class="justify-content-end">
        {{ formatMethods(SC.amt) }}{{ SC.amt != "" ? SC.amt_unit_nm : "" }}
      </div>
      <div class="justify-content-end">
        {{ formatMethods(SC.premium)
        }}{{ SC.premium != "" ? contractData.curr_nm : "" }}
      </div>
    </div>
    <!-- 應繳保費合計(折減前) -->
    <div
      class="contractItem__totalDiscount"
      :class="{
        final: !contractData.has_disc,
      }"
    >
      <div>
        {{ contractData.pay_freq_nm.split("繳")[0] }}應繳保費(保費折減前)合計:
      </div>
      <div>
        {{ formatMethods(contractData.total_premium)
        }}{{ contractData.curr_nm }}
      </div>
    </div>
    <!-- 應繳保費合計(折減後) -->
    <div
      class="contractItem__totalDiscount final"
      v-if="contractData.has_disc"
    >
      <div>
        {{ contractData.pay_freq_nm.split("繳")[0] }}應繳保費(保費折減後) 合計:
      </div>
      <div>
        {{ formatMethods(contractData.total_disc_premium)
        }}{{ contractData.curr_nm }}
      </div>
    </div>
    <div class="contractItem__discountDesc" v-if="contractData.disc_text_list.length > 0">
      <div v-for="(disc, index) in contractData.disc_text_list" :key="index">
        {{ disc }}
      </div>
    </div>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
export default {
  mixins: [mf_Mixin],
  props: ["contractData", "contractIndex"],
};
</script>

<style lang="scss" scoped>
.contractItem {
  max-width: 904px;
  width: 100%;
  border-radius: 4px;
  border: solid 1px #53c480;
  &__index {
    padding: 15px;
    line-height: 1.38;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 700;
    color: #027a39;
    background-color: #e5f6ec;
  }
  &__title {
    width: 100%;
    display: flex;
    font-weight: 700;
    color: #027a39;
    background-color: #e5f6ec;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    & > div {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 3px 7px;
    }
    & > div:nth-of-type(1) {
      min-height: 50px;
      width: 45%;
    }
    & > div:nth-of-type(2) {
      width: 6%;
    }
    & > div:nth-of-type(3) {
      width: 6%;
    }
    & > div:nth-of-type(4) {
      width: 13%;
    }
    & > div:nth-of-type(5) {
      width: 15%;
    }
    & > div:nth-of-type(6) {
      width: 15%;
    }
  }
  //主約
  &__MC {
    width: 100%;
    display: flex;
    color: #323a45;
    background-color: #fff;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    & > div {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 3px 7px;
    }
    & > div:nth-of-type(1) {
      min-height: 50px;
      width: 45%;
    }
    & > div:nth-of-type(2) {
      width: 6%;
    }
    & > div:nth-of-type(3) {
      width: 6%;
    }
    & > div:nth-of-type(4) {
      width: 13%;
    }
    & > div:nth-of-type(5) {
      width: 15%;
    }
    & > div:nth-of-type(6) {
      width: 15%;
    }
  }
  //   附約
  &__SC {
    width: 100%;
    display: flex;
    color: #323a45;
    background-color: #f5f5f5;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    & > div {
      border: solid 1px rgba(194, 196, 199, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 3px 7px;
    }
    & > div:nth-of-type(1) {
      min-height: 50px;
      width: 45%;
    }
    & > div:nth-of-type(2) {
      width: 6%;
    }
    & > div:nth-of-type(3) {
      width: 6%;
    }
    & > div:nth-of-type(4) {
      width: 13%;
    }
    & > div:nth-of-type(5) {
      width: 15%;
    }
    & > div:nth-of-type(6) {
      width: 15%;
    }
  }
  //   應繳保費合計(折減前)
  &__totalDiscount {
    padding: 10px;
    line-height: 1.38;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 700;
    color: #323a45;
    background-color: #fff;
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    &.final {
      color: #03c;
      background-color: #fff3c2;
    }
  }
  &__discountDesc {
    border-top: solid 1px rgba(194, 196, 199, 0.8);
    line-height: 1.38;
    padding: 8px 10px;
  }
}
</style>
